import React from "react";
import "./popupTrans.css";
import { PopupTransProps, PopupTransState } from "./interface";
import { ConfigService } from "../../../assets/lib/kookit-extra-browser.min";
import axios from "axios";
import { Trans } from "react-i18next";
import toast from "react-hot-toast";
import {
  getDefaultTransTarget,
  getWebsiteUrl,
  handleContextMenu,
  openExternalUrl,
} from "../../../utils/common";
import DatabaseService from "../../../utils/storage/databaseService";
import { checkPlugin } from "../../../utils/common";
import { getTransStream } from "../../../utils/request/reader";
declare var window: any;
class PopupTrans extends React.Component<PopupTransProps, PopupTransState> {
  constructor(props: PopupTransProps) {
    super(props);
    this.state = {
      translatedText: "",
      originalText: "",
      transService: ConfigService.getReaderConfig("transService") || "",
      transTarget: ConfigService.getReaderConfig("transTarget"),
      transSource: ConfigService.getReaderConfig("transSource"),
      isAddNew: false,
      isFinishOutput: false,
    };
  }
  componentDidMount() {
    let originalText = this.props.originalText.replace(/(\r\n|\n|\r)/gm, "");
    this.setState({ originalText: originalText });
    if (!this.state.transService) {
      this.setState({
        isAddNew: true,
      });
    }

    this.handleTrans(originalText);
  }

  handleTrans = async (text: string) => {
    if (
      this.state.transService &&
      this.state.transService !== "official-ai-trans-plugin"
    ) {
      let plugin = this.props.plugins.find(
        (item) => item.key === this.state.transService
      );
      if (!plugin) {
        return;
      }
      let translateFunc = plugin.script;
      // eslint-disable-next-line no-eval
      eval(translateFunc);
      window
        .translate(
          text,
          ConfigService.getReaderConfig("transSource") || "",
          ConfigService.getReaderConfig("transTarget") ||
            getDefaultTransTarget(plugin.langList),
          axios,
          plugin.config
        )
        .then((res: string) => {
          if (res.startsWith("https://")) {
            openExternalUrl(res, true, "trans");
          } else {
            this.setState({
              translatedText: res,
            });
          }
        })
        .catch((err) => {
          toast.error(
            this.props.t("Translation failed") +
              ": " +
              (err instanceof Error ? err.message : String(err))
          );
          console.error(err);
        });
    } else if (
      this.props.isAuthed &&
      ConfigService.getReaderConfig("isDisableAI") !== "yes"
    ) {
      this.setState({
        transService: "official-ai-trans-plugin",
        isAddNew: false,
      });
      let plugin = this.props.plugins.find(
        (item) => item.key === "official-ai-trans-plugin"
      );
      if (!plugin) {
        return;
      }
      let isFirst = true;
      let targetLang =
        ConfigService.getReaderConfig("transTarget") ||
        getDefaultTransTarget(plugin.langList);
      if (targetLang === "Traditional Chinese") {
        targetLang = "繁体中文";
      }
      await getTransStream(
        text,
        ConfigService.getReaderConfig("transSource") || "Automatic",
        ConfigService.getReaderConfig("transTarget") ||
          getDefaultTransTarget(plugin.langList),
        (result) => {
          if (result && result.done) {
            this.setState({ isFinishOutput: true });
            return;
          }
          if (result && result.text) {
            if (isFirst) {
              this.setState({
                translatedText: result.text,
              });
              isFirst = false;
            } else {
              this.setState({
                translatedText: this.state.translatedText + result.text,
              });
            }
          }
        }
      );
      this.setState({ isFinishOutput: true });
    }
  };
  handleChangeService(target: string) {
    this.setState({ transService: target }, () => {
      ConfigService.setReaderConfig("transService", target);
      let plugin = this.props.plugins.find(
        (item) => item.key === this.state.transService
      );
      if (!plugin) {
        return;
      }
      let autoValue = plugin.autoValue;
      this.setState(
        {
          transSource: autoValue,
          transTarget: getDefaultTransTarget(plugin.langList),
        },
        () => {
          ConfigService.setReaderConfig(
            "transTarget",
            getDefaultTransTarget(plugin?.langList)
          );
          ConfigService.setReaderConfig("transSource", autoValue);
          this.handleTrans(
            this.props.originalText.replace(/(\r\n|\n|\r)/gm, "")
          );
        }
      );
    });
  }
  render() {
    const renderNoteEditor = () => {
      return (
        <div className="trans-container">
          <div className="trans-service-selector-container">
            <div
              className="trans-service-selector-inactive"
              onClick={() => {
                this.props.handleOpenMenu(false);
                this.props.handleMenuMode("");
                this.props.handleSetting(true);
                this.props.handleSettingMode("plugins");
              }}
            >
              <span className="icon-add trans-add-icon"></span>
              <Trans>Add</Trans>
            </div>
            {this.props.plugins
              .filter((item) => item.type === "translation")
              .map((item) => {
                return (
                  <div
                    className={
                      this.state.transService === item.key
                        ? "trans-service-selector"
                        : "trans-service-selector-inactive"
                    }
                    onClick={() => {
                      this.setState({ isAddNew: false });
                      this.handleChangeService(item.key);
                    }}
                  >
                    <span className={`icon-${item.icon} trans-icon`}></span>
                    {this.props.t(item.displayName)}
                  </div>
                );
              })}
          </div>
          {this.state.isAddNew && (
            <div
              style={{
                marginTop: "50px",
                textAlign: "center",
                fontSize: "17px",
                color: "#f16464",
              }}
            >
              <span
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  textAlign: "center",
                }}
                onClick={() => {
                  this.props.handleOpenMenu(false);
                  this.props.handleMenuMode("");
                  this.props.handleSetting(true);
                  this.props.handleSettingMode("plugins");
                }}
              >
                <Trans>Add new plugin</Trans>
              </span>
            </div>
          )}
          {!this.state.isAddNew && (
            <>
              <div className="trans-lang-selector-container">
                <div className="original-lang-box">
                  <select
                    className="original-lang-selector"
                    style={{ maxWidth: "120px", margin: 0 }}
                    onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                      let targetLang = event.target.value;
                      ConfigService.setReaderConfig("transSource", targetLang);
                      this.handleTrans(
                        this.props.originalText.replace(/(\r\n|\n|\r)/gm, "")
                      );
                    }}
                  >
                    {this.props.plugins.find(
                      (item) => item.key === this.state.transService
                    )?.langList &&
                      Object.keys(
                        this.props.plugins.find(
                          (item) => item.key === this.state.transService
                        )?.langList as any
                      ).map((item, index) => {
                        return (
                          <option
                            value={item}
                            key={index}
                            className="add-dialog-shelf-list-option"
                            selected={
                              ConfigService.getReaderConfig("transSource") ===
                              item
                                ? true
                                : false
                            }
                          >
                            {this.props.t(
                              Object.values(
                                this.props.plugins.find(
                                  (item) => item.key === this.state.transService
                                )?.langList as any[]
                              )[index]
                            )}
                          </option>
                        );
                      })}
                  </select>
                </div>
                <div className="trans-lang-box">
                  <select
                    className="trans-lang-selector"
                    style={{ maxWidth: "120px", margin: 0 }}
                    onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                      let targetLang = event.target.value;
                      ConfigService.setReaderConfig("transTarget", targetLang);
                      this.handleTrans(
                        this.props.originalText.replace(/(\r\n|\n|\r)/gm, "")
                      );
                    }}
                  >
                    {this.props.plugins.find(
                      (item) => item.key === this.state.transService
                    )?.langList &&
                      Object.keys(
                        this.props.plugins.find(
                          (item) => item.key === this.state.transService
                        )?.langList as any
                      ).map((item, index) => {
                        return (
                          <option
                            value={item}
                            key={index}
                            className="add-dialog-shelf-list-option"
                            selected={
                              (ConfigService.getReaderConfig("transTarget") ||
                                getDefaultTransTarget(
                                  this.props.plugins.find(
                                    (item) =>
                                      item.key === this.state.transService
                                  )?.langList
                                )) === item
                                ? true
                                : false
                            }
                          >
                            {this.props.t(
                              Object.values(
                                this.props.plugins.find(
                                  (item) => item.key === this.state.transService
                                )?.langList as any[]
                              )[index]
                            )}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>
              <div className="trans-box">
                <div className="original-text-box">
                  <div className="original-text">{this.state.originalText}</div>
                </div>
                <div className="trans-text-box">
                  <div className="trans-text">
                    {this.state.translatedText}
                    {this.state.transService.includes("ai-trans") &&
                      this.state.isFinishOutput && (
                        <p
                          className="dict-learn-more"
                          style={{ color: "#f16464" }}
                        >
                          {this.props.t("Generated with AI")}
                        </p>
                      )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      );
    };

    return renderNoteEditor();
  }
}
export default PopupTrans;
